import { energyFormParametersGeneration } from './SubscriptionForm/Energy/energyFormParametersGeneration'
import { insuranceFormParametersGeneration } from './SubscriptionForm/Insurance/insuranceFormParametersGeneration'
import { telecomFormParametersGeneration } from './SubscriptionForm/Telecom/telecomFormParametersGeneration'

const SaveForm = async (
  action = '',
  headers,
  applicationType = 'telecom',
  customerData,
  billingData,
  electricityMeterData,
  gasMeterData,
  mainAddressData,
  invoicingAddressData,
  telecomContractData,
  energyContractData,
  telecomCharacteristicsData,
  energyCharacteristicsData,
  energyConsumptionData,
  energyEstimationData,
  propaneData,
  insuranceContractData,
  insuranceCharacteristicsData,
  id,
  country,
  saveUrl,
  callback,
  identityData = {},
  residenceAddressData = {},
) => {
  let options = null
  if (applicationType === 'telecom') {
    options = telecomFormParametersGeneration(
      customerData,
      billingData,
      mainAddressData,
      telecomContractData,
      telecomCharacteristicsData,
      id,
      country,
      action,
      identityData,
      residenceAddressData,
      invoicingAddressData,
    )
  }
  if (applicationType === 'assurance') {
    options = insuranceFormParametersGeneration(
      customerData,
      billingData,
      mainAddressData,
      insuranceContractData,
      insuranceCharacteristicsData,
      id,
      country,
      action,
    )
  }
  if (applicationType === 'energie') {
    options = energyFormParametersGeneration(
      customerData,
      billingData,
      electricityMeterData,
      gasMeterData,
      propaneData,
      energyContractData,
      energyCharacteristicsData,
      energyConsumptionData,
      energyEstimationData,
      mainAddressData,
      invoicingAddressData,
      id,
      country,
      action,
      {},
      identityData,
      residenceAddressData,
    )
  }
  headers.body = options
  return new Promise((resolve, reject) => {
    fetch(saveUrl, headers)
      .then(response =>
        response.json().then(json => {
          callback(json, response.status, action)
          resolve({ ...json, status: response.status })
        }),
      )
      .catch(error => {
        console.error(error)
        reject(error)
      })
  })
}

export default SaveForm
